<template src='./buttonApplication.pug' lang='pug'></template>

<script>
export default {
  name: 'ButtonApplication',

  props: {
    btnDesc: {
      type: String,
      required: true
    },
    btnImg: {
      type: String,
      required: true
    },
    btnActive: {
      type: Boolean,
      required: true
    },
    btnClickFunction: {
      type: Function,
      required: true
    },
    btnWidth: {
      type: String,
      required: true
    },
    btnAppId: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      equalsCartoesImg: require('../../../assets/icones_app/cartao_azul.svg'),
      equalsBankingImg: require('../../../assets/icones_app/banco_branco.svg')
    }
  },

  methods: {
    roundedClass () {
      return this.btnActive ? 'rounded-div-active' : 'rounded-div'
    },

    activeMarkClass () {
      return this.btnActive ? 'mark' : 'transp-mark'
    },

    activeDescClass () {
      return this.btnActive ? 'app-font bold' : 'app-font'
    }
  }
}
</script>

<style lang='css'>
.rounded-div-active {
  width: 120px;
  height: 120px;
  border: 2px solid #012351;
  border-radius: 50%;
  text-align: center;
  background: #012351;
}

.rounded-div {
  width: 120px;
  height: 120px;
  border: 2px solid #012351;
  border-radius: 50%;
  text-align: center;
  background: white;
}

.app-font {
  font-family: 'Inter', sans-serif;
  color: #012351;
  font-size: 15px;
  text-align: center;
}

#Botao-Aplicacao-Wrapper:hover .app-font {
  font-weight: bold;
}

.mark {
  color: white;
  background: #40b9bb;
  border-radius: 13px;
  padding: 8px 15px 8px 15px;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 14px;
}

#Botao-Aplicacao-Wrapper:hover .mark {
  -webkit-box-shadow: 0px 0px 30px 0px #999;
  -moz-box-shadow: 0px 0px 30px 0px #999;
  box-shadow: 0px 0px 30px 0px #999;
  transition: all linear 0.2s;
}

.transp-mark {
  background: transparent;
  color: transparent;
}

#Botao-Aplicacao-Wrapper {
  cursor: pointer;
  padding-top: 20px;
}

.img-troca-app {
  padding-top: 25px;
}

#Botao-Aplicacao-Wrapper:hover .img-troca-app {
  -webkit-box-shadow: 0px 0px 30px 0px #999;
  -moz-box-shadow: 0px 0px 30px 0px #999;
  box-shadow: 0px 0px 30px 0px #999;
  transition: all linear 0.2s;
}
</style>



// WEBPACK FOOTER //
// ButtonApplication.vue?6fdf33b8